import PropTypes from "prop-types";
import P2Alert from "../../P2Alert/P2Alert";
function P2Checkbox(props) {
  const handleClick = () => {
    if (props.onClick && props.variant !== "disabled") {
      props.onClick();
    }
  };

  const getIconClassName = (props) => {
    if (props.variant === "default" && props.isActive) {
      return "active-tick";
    } else if (props.variant === "disabled") {
      return "disabled";
    } else {
      return "";
    }
  };

  const iconClassName = `polymer-checkbox-form__icon ${getIconClassName(props)} ${props.size === "medium" ? "medium-checkbox" : "small-checkbox"}`;
  const activeTickClassName = `polymer-checkbox-form__icon-active-tick ${props.variant === "disabled" ? "disabled" : ""}`;
  const active = "#0c8188";
  const disabled = "#AAAAAA";
  return (
    <>
      <div className="polymer-checkbox-form">
        <div onClick={handleClick} className={iconClassName}>
          {props.isActive && (
            <div className={activeTickClassName}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.6663 3.5L5.24967 9.91667L2.33301 7"
                  stroke={props.variant === "disabled" ? disabled : active}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
        </div>
        {props.description && <div className="polymer-checkbox-form__description">{props.description}</div>}
      </div>
      {props.forceError && !props.isActive && props.variant !== "disabled" &&
        <div style={{ marginTop: 24 }}>
          <P2Alert variant={"danger"} text={"Please check the checkbox"}/>
        </div>}
    </>
  );
}

export default P2Checkbox;

P2Checkbox.propTypes = {
  variant: PropTypes.oneOf(["default", "disabled"]),
  isActive: PropTypes.bool,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium"]),
  forceError: PropTypes.bool
};

P2Checkbox.defaultProps = {
  variant: "default",
  isActive: false,
  description: "",
  size: "small",
  forceError: false
};
